
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }

  if(Flits.Metafields.IS_WISHLIST_PAID && Flits.Metafields.IS_WISHLIST_ENABLE){
    Flits.LoadStyleScript('wishlistJs',window.flitsObjects.allCssJs.wishlistJs.url);
  }

  var ajaxWishlistViewFunction = function(xhrOrFetch) {
    var url = this._url;

    (-1 !== url.indexOf("?view=product")) && Flits.dispatchEvent("Flits:AjaxWishlist", { 
      response: this,
      xhrOrFetch: xhrOrFetch
    })
  };
  Flits.addAjaxEvents(ajaxWishlistViewFunction);
  Flits.addFetchEvents(ajaxWishlistViewFunction);

  Flits(document).on("Flits:AjaxWishlist", function(){
    setTimeout(function(){  
      var grid = Flits(".template-product").find(".filts-wishlist-product-style .flits-wls-button");
      Flits(grid).each(function(index,single_grid_item){
        var handle = Flits(single_grid_item).attr('data-flits-product-handle');
        Flits(single_grid_item).parent().css('display','flex');
        Flits(single_grid_item).find('.flits-wls-icon-with-text-text').css('display','flex');

        if(Flits.isProductAddedInWishlist(handle)){ 
          Flits(single_grid_item).removeClass("flits-wls-inactive");
          Flits(single_grid_item).addClass("flits-wls-active");
          Flits(single_grid_item).find(".flits-wls-icon-with-text-text").html(Flits.t('Flits.locals.wishlisted_product_page.remove_from_wishlist_button', 'Remove from Wishlist'));
        }
      });     
    }, 1000);
  });

var ajaxWishlistViewFunctionRecommendations = function(xhrOrFetch) {
    var url = this._url;

    (-1 !== url.indexOf("/recommendations/products?section_id=")) && Flits.dispatchEvent("Flits:AjaxWishlistRecommendations", { 
      response: this,
      xhrOrFetch: xhrOrFetch
    })
  };
  Flits.addAjaxEvents(ajaxWishlistViewFunctionRecommendations);
  Flits.addFetchEvents(ajaxWishlistViewFunctionRecommendations);

  Flits(document).on("Flits:AjaxWishlistRecommendations", function(){
    setTimeout(function(){  
     var grid = Flits(".template-product").find(".flits-wishlist-colection-style .flits-wls-button");
      Flits(grid).each(function(index,single_grid_item){
        var handle = Flits(single_grid_item).attr('data-flits-product-handle');
        Flits(single_grid_item).parent().css('display','flex');
        Flits(single_grid_item).find('.flits-wls-icon-with-text-text').css('display','flex');

        if(Flits.isProductAddedInWishlist(handle)){ 
          Flits(single_grid_item).removeClass("flits-wls-inactive");
          Flits(single_grid_item).addClass("flits-wls-active");
          Flits(single_grid_item).find(".flits-wls-icon-with-text-text").html(Flits.t('Flits.locals.wishlisted_product_page.remove_from_wishlist_button', 'Remove from Wishlist'));
        }
      });     
    }, 1000);
  });
  
Flits(document).on('click', '.multi-collection-nav-item', (function(event) {
     setTimeout(function(){  
      var grid = Flits(".template-index").find(".flits-wishlist-colection-style .flits-wls-button");
      Flits(grid).each(function(index,single_grid_item){
        var handle = Flits(single_grid_item).attr('data-flits-product-handle');
        Flits(single_grid_item).parent().css('display','flex');
        Flits(single_grid_item).find('.flits-wls-icon-with-text-text').css('display','flex');

        if(Flits.isProductAddedInWishlist && Flits.isProductAddedInWishlist(handle)){ 
          Flits(single_grid_item).removeClass("flits-wls-inactive");
          Flits(single_grid_item).addClass("flits-wls-active");
          Flits(single_grid_item).find(".flits-wls-icon-with-text-text").html(Flits.t('Flits.locals.wishlisted_product_page.remove_from_wishlist_button', 'Remove from Wishlist'));
        }
      });     
    }, 1000);
    })
);
  
// Flits(window).on('load',function(event) {
//     setTimeout(function(){ 
//       function wishListCollection() {
//        let collectionBtn = Flits('.flits-wishlist-colection');
//           parseInt(Flits.wishlistButton.settings.isCountEnable) && Flits(collectionBtn).find('.flits-wls-count-btn').css('display', 'flex'),
//             Flits(collectionBtn).show(),
//             Flits('.flits-wishlist-colection:not(.flits-template)').parent().attr('data-flits', 'wishlist-collection-parent');
//       }
//       function wishlistLocalData() {
//         var settings = {
//             automaticAppendDivFunction: function() {},
//             isWishlistAutomatic: 1,
//             wslBtnType: 1,
//             isCountEnable: 0,
//             addtocartSelectors: ["form[action='/cart/add']"],
//             wishListBtnDomSelector: 'flits-wishlist-dom',
//             wishlist_base_url: '/wishlist',
//             add_wsl_url: '/add_to_wishlist',
//             remove_wsl_url: '/remove_from_wishlist',
//             wishlistHandle: 'flits_wishlist_products',
//             wishlistLastUpdate: 'last_wishlist_product_update',
//             clicked_add_button: '',
//             appearance_style: {
//                 before_heart_clr: '#000000',
//                 before_btn_clr: '#fff',
//                 before_text_clr: '#f5020f',
//                 before_border_clr: '#000000',
//                 after_heart_clr: '#fc0303',
//                 after_btn_clr: '#080707',
//                 after_text_clr: '#f5faf9',
//                 after_border_clr: '#f7f5fa',
//                 collection_before_heart_clr: '#000000',
//                 collection_after_heart_clr: '#fc0303'
//             }
//         };
//         var wishlitsLocalHandles = Flits.getLocalStorage(Flits.wishlistButton.settings.wishlistHandle);
//         if (wishlitsLocalHandles) {
//           var wishlitsLocalHandlesArray = wishlitsLocalHandles.split(',');
//           console.log(wishlitsLocalHandlesArray.length);
//           for (var i = 0; i < wishlitsLocalHandlesArray.length; i++) {
//             var s = Flits("*[data-flits-product-handle='" + wishlitsLocalHandlesArray[i] + "']");	
//             var wishlitsLocalHandlesnew = Flits.getLocalStorage(Flits.wishlistButton.settings.wishlistHandle);
//             var pro_handle = s.attr('data-flits-product-handle');
//             if(Flits.isProductAddedInWishlist(pro_handle)){ 
//               s.removeClass("flits-wls-inactive")
//               s.addClass("flits-wls-active")
//               s.attr("data-tippy-content",Flits.t('Flits.locals.wishlisted_product_page.remove_from_wishlist_button','Remove from Wishlist'));
//             }     
//           }
//         }
//       }
//       wishlistLocalData();
//       wishListCollection();
//     }, 2500);
//   });

var ajaxCartViewFunction = function(xhrOrFetch) {
var url = this._url;   
if ((url.indexOf('/cart/add.js') !== -1 || url.indexOf('/cart/change.js') !== -1)) {
  Flits.dispatchEvent('Flits:AjaxCart:AjaxCartRendered', {
        response: this,
        xhrOrFetch: xhrOrFetch
    })
  }
};
Flits.addFetchEvents(ajaxCartViewFunction);
Flits.addAjaxEvents(ajaxCartViewFunction);

Flits(document).on("Flits:AjaxCart:AjaxCartRendered", function(response){
 setTimeout(function(){
  Flits.ajax({
    url: '/cart.json', 
    type: 'get',
    dataType: 'json',
    success: function(data){
      console.log(data);
        var cart_items = data.items;
        wls_ajax_cart_fun(cart_items);
    },
    error: function(data){
    }
  });
   }, 1000)
});

function wls_ajax_cart_fun(cart_item){
  var line_item = Flits(".side-cart-items").find(".side-cart-item");
  for(var i=0;i<line_item.length;i++){
    var ajax_wls_element = Flits("#ajax_cart_wls_btn").find(".flits-wishlist-colection").clone();
    Flits(line_item[i]).find(".line-item-update").append(ajax_wls_element);
    Flits(line_item[i]).find(".flits-wishlist-colection .flits-wls-button").attr({
      "data-flits-product-id" : cart_item[i].product_id,
      "data-flits-product-title" : cart_item[i].product_title,
      "data-flits-product-handle" : cart_item[i].handle,
      "data-flits-product-image" : cart_item[i].image
    });
  }
}

  Flits(document).on('Flits:order:AllLoaded', function(event){
    setTimeout(function(){
      Flits('#flits-order-list .flits-order-list').find('.flits-view-order-button')[0].click();
      Flits('#flits-order-mobile-list .flits-order-list').find('.flits-view-order-button')[0].click();
      }, 800);
  });
  
function getDate(timestamp) {
    var date = new Date(timestamp);
    var day = date.getDate();
    var month = date.getMonth() + 1;
    var formattedDate = day + " " + getMonthName(month);
    return formattedDate;
}
function getMonthName(monthNumber) {
    var months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    return months[monthNumber - 1];
}
  
    Flits(document).on('click', '.flits-view-order-button', (function(event) {
        let myArray = [];
        let storevarientID = [];
        var clickEvent = this;
        var orderID = Flits(this).attr('order-id-tracktor');
        var apiKey = "MDdjNzhiNTg0MmQ3N2Q0MDA2OTZkOGVj";
        const url = "https://corsproxy.io/?" + encodeURIComponent("https://www.theshoppad.com/apps/tracktor/api/admin/jadebluelifestyle/orders/" + orderID + ".json");
        Flits.ajax({
            url: url,
            method: "GET",
            dataType: "json",
            headers: {
                "x-api-key": apiKey
            },
            success: function(data) {
                var TrackingHtmlDOM = "";
                var GetOrderFulfillments = data.order.fulfillments;
                var DOMSelector = Flits(clickEvent).parents('.flits-order-card').find('.flits-tracktor-details .progtrckr li');
                for (let x = 0; x < GetOrderFulfillments.length; x++) {
                    myArray.push(GetOrderFulfillments[x].status.ordered);
                    myArray.push(GetOrderFulfillments[x].status.order_ready);
                    myArray.push(GetOrderFulfillments[x].status.in_transit);
                    myArray.push(GetOrderFulfillments[x].status.out_for_delivery);
                    myArray.push(GetOrderFulfillments[x].status.delivered);
                    myArray.push(GetOrderFulfillments[x].status.exception);
                    myArray.push(GetOrderFulfillments[x].status.out_for_delivery);
                    var getVarientItemID = data.order.fulfillments[x].line_items;
                    for (let index = 0; index < getVarientItemID.length; index++) {
                    let getVarientIDTOcheck = Flits(clickEvent).parents('.flits-order-card').find('.flits-tracktor-details')[x];
                    let getVariantAttr = Flits(getVarientIDTOcheck).attr('flits-variant-id');
                    var myGlobalArray = window.myGlobalArray; 
                    var checkStatus = Flits.inArray(getVarientItemID[index].variant_id, myGlobalArray);
                      
                      if (checkStatus !== -1) {
                      console.log(myArray);
                      for (var i = 0; i < myArray.length; i++) {
                          if (myArray[i].all.length >= 1) { 
                            Flits(clickEvent).parents('.flits-order-card').find('[flits-variant-id='+ getVarientItemID[index].variant_id +']').css('display', 'block');
                            var StatusLabel = myArray[i].label;
                            switch (StatusLabel) {
                                case "Ordered":
                                    var OrderliSelector = Flits(clickEvent).parents('.flits-order-card').find('[flits-variant-id='+ getVarientItemID[index].variant_id +'] .progtrckr li.flits-ordered');
                                    Flits(clickEvent).parents('.flits-order-card').find('[flits-variant-id='+ getVarientItemID[index].variant_id +'] .order-date').append(getDate(myArray[i].latest.datetime));
                                    //Flits(OrderliSelector).append('<span>' + getDate(myArray[i].latest.datetime) + '</span>');
                                    Flits(OrderliSelector).removeClass('progtrckr-todo');
                                    Flits(OrderliSelector).addClass('progtrckr-done');
                                    break;
                      
                                case "Order Ready":
                                    var OrderliSelector = Flits(clickEvent).parents('.flits-order-card').find('[flits-variant-id='+ getVarientItemID[index].variant_id +'] .progtrckr li.flits-ordered-ready');
                                   // Flits(OrderliSelector).append('<span>' + getDate(myArray[i].latest.datetime) + '</span>');
                                    Flits(OrderliSelector).removeClass('progtrckr-todo');
                                    Flits(OrderliSelector).addClass('progtrckr-done');
                                    break;
                      
                                case "In Transit":
                                    var OrderliSelector = Flits(clickEvent).parents('.flits-order-card').find('[flits-variant-id='+ getVarientItemID[index].variant_id +'] .progtrckr li.flits-intransit');
                                    //Flits(OrderliSelector).append('<span>' + getDate(myArray[i].latest.datetime) + '</span>');
                                    Flits(OrderliSelector).removeClass('progtrckr-todo');
                                    Flits(OrderliSelector).addClass('progtrckr-done');
                                    break;
                      
                                case "Out for Delivery":
                                    var OrderliSelector = Flits(clickEvent).parents('.flits-order-card').find('[flits-variant-id='+ getVarientItemID[index].variant_id +'] .progtrckr li.flits-outfordelivery');
                                   // Flits(OrderliSelector).append('<span>' + getDate(myArray[i].latest.datetime) + '</span>');
                                    Flits(OrderliSelector).removeClass('progtrckr-todo');
                                    Flits(OrderliSelector).addClass('progtrckr-done');
                                    break;
                      
                                case "Delivered":
                                    var OrderliSelector = Flits(clickEvent).parents('.flits-order-card').find('[flits-variant-id='+ getVarientItemID[index].variant_id +'] .progtrckr li.flits-delivered');
                                    //Flits(OrderliSelector).append('<span>' + getDate(myArray[i].latest.datetime) + '</span>');
                                    Flits(OrderliSelector).removeClass('progtrckr-todo');
                                    Flits(OrderliSelector).addClass('progtrckr-done');
                                    break;

                                case "Exception":
                                    var OrderliSelector = Flits(clickEvent).parents('.flits-order-card').find('[flits-variant-id='+ getVarientItemID[index].variant_id +'] .progtrckr li.flits-exception');
                                   // Flits(OrderliSelector).append('<span>' + getDate(myArray[i].latest.datetime) + '</span>');
                                    //Flits(OrderliSelector).nextAll('li').remove();
                                    Flits(OrderliSelector).parent().find('.flits-intransit').remove();
                                    Flits(OrderliSelector).parent().find('.flits-outfordelivery').remove();
                                    Flits(OrderliSelector).parent().find('.flits-delivered').remove();
                                    Flits(OrderliSelector).find('span#text-method').text(myArray[i].all[0].message);
                                    Flits(OrderliSelector).find('span#text-method').attr('data-tippy-content', myArray[i].all[0].message);
                                    //Flits(OrderliSelector).find('span#exception-msg').text(myArray[i].all[0].message);
                                    // Flits(OrderliSelector).removeClass('progtrckr-todo');
                                    // Flits(OrderliSelector).addClass('progtrckr-done');
                                    Flits(OrderliSelector).closest(".flits-tracktor-details").addClass('flits_exception');
                                    Flits(OrderliSelector).parents(".progtrckr").attr('data-progtrckr-steps','3');
                                    Flits(OrderliSelector).css('display','block');
                                  break;
                      
                                default:
                                    console.log("No matching option");
                            }
                        }
                        }
                      }
                 
                    }
                }
            },
            error: function(xhr, status, error) {
                // Handle error
                //Flits("#result").html("Error: " + error);
            }
        });

      // var clickEvent = this;
      // const Authurl = "https://corsproxy.io/?https://api.fynd.com/service/panel/authentication/v1.0/company/320/oauth/token";
      //     Flits.ajax({
      //        url: Authurl,
      //        method: "POST",
      //        dataType: "json",
      //        success: function(data) {
      //           console.log(data);
      //        },
      //       error: function(xhr, status, error) {
      //            // Handle error
      //            //Flits("#result").html("Error: " + error);
      //        }
      //     });
    }));

  Flits(document).on('Flits:AccountPage:Loaded', function(event){  
  var data = event.detail;
  data.settings.active_tab = '#order';
});

   Flits(document).on('Flits:SocialLogin:Loaded', function(event){  
    setTimeout(function(){
      if (location.pathname.indexOf("/account") == -1){  
        Flits.setLocalStorage('flits_before_login_url','/account');
      }
    }, 800);
  });

  Flits(window).load(function() {  
    if (location.pathname.indexOf("/account") == -1){     
      if (location.pathname.indexOf("checkout") != -1)
      {
        Flits.setLocalStorage('flits_before_login_url',location.pathname);
      }else{
        Flits.setLocalStorage('flits_before_login_url','/account');
      }
    }
  });
  Flits(document).on("Flits:AccountPage:Loaded", function (event) {
    Flits(".logoutcustom").on("click", function () {
      event.preventDefault();
      handleLogout();
    });   });
  
}(Flits));
